// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3qb4O","legacyBtn":"MutateMid_legacyBtn__2XGm9"};